import * as Sentry from '@sentry/react';

const reportWebVitals = () => {
  import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
    const sendToSentry = (metric: { name: string; value: number }) => {
      Sentry.metrics.distribution(metric.name, metric.value, {
        unit: metric.name === 'CLS' ? '' : 'millisecond',
      });
    };
    getCLS(sendToSentry);
    getFID(sendToSentry);
    getFCP(sendToSentry);
    getLCP(sendToSentry);
    getTTFB(sendToSentry);
  });
};

export default reportWebVitals;
